import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Integration = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Integration' {...props}>
    <path fill='none' stroke='#231F20' strokeWidth='2' d='M5,21 L23,21 L23,9 L5,9 M19,15 L1,15 L1,3 L19,3' />
  </StyledIcon>
);
